// extracted by mini-css-extract-plugin
export default {"MONTH":"sc9hz4","month":"sc9hz4","DAY":"QQpaRP","day":"QQpaRP","YEAR":"MYzB6t","year":"MYzB6t","fields":"s4U9K6","mobile":"mNLImb"};